export const mock = {
    Quality: [
        {
            id: 1,
            value: '720p',
        },
        {
            id: 2,
            value: '1080p',
        },
        {
            id: 3,
            value: '2160p',
        },
        {
            id: 4,
            value: '3D',
        }
    ],
    Genre: [
        {
            id: 1,
            value: 'Action'
        },
        {
            id: 2,
            value: 'Adventure'
        },
        {
            id: 3,
            value: 'Animation'
        },
        {
            id: 4,
            value: 'Biography'
        },
        {
            id: 5,
            value: 'Comedy'
        },
        {
            id: 6,
            value: 'Crime'
        },
        {
            id: 7,
            value: 'Documentary'
        },
        {
            id: 8,
            value: 'Drama'
        },
        {
            id: 9,
            value: 'Family'
        },
        {
            id: 10,
            value: 'Fantasy'
        },
        {
            id: 11,
            value: 'Film-Noir'
        },
        {
            id: 12,
            value: 'Game-Show'
        },
        {
            id: 13,
            value: 'History'
        },
        {
            id: 14,
            value: 'Horror'
        },
        {
            id: 15,
            value: 'Music'
        },
        {
            id: 16,
            value: 'Musical'
        },
        {
            id: 17,
            value: 'Mystery'
        },
        {
            id: 18,
            value: 'News'
        },
        {
            id: 19,
            value: 'Reality-TV'
        },
        {
            id: 20,
            value: 'Romance'
        },
        {
            id: 21,
            value: 'Sci-Fi'
        },
        {
            id: 22,
            value: 'Sport'
        },
        {
            id: 23,
            value: 'talk-show'
        },
        {
            id: 24,
            value: 'Thriller'
        },
        {
            id: 25,
            value: 'War'
        },
        {
            id: 26,
            value: 'western'
        }
    ],
    Rating: [
        {
            id: 1,
            value: 9,
        },
        {
            id: 2,
            value: 8,
        },
        {
            id: 3,
            value: 7,
        },
        {
            id: 4,
            value: 6,
        },
        {
            id: 5,
            value: 5,
        },
        {
            id: 6,
            value: 4,
        }, 
        {
            id: 7,
            value: 3,
        }, 
        {
            id: 8,
            value: 2,
        }, 
        {
            id: 9,
            value: 1,
        }
    ],
    Year:[
        {
            id:1,
            value:'2022'
        },
        {
            id:2,
            value:'2021'
        },
        {
            id:3,
            value:'2020'
        },
        {
            id:4,
            value:'2019'
        },
        {
            id:5,
            value:'2015-2018'
        }, {
            id:6,
            value:'2010-2014'
        }, {
            id:7,
            value:'2000-2009'
        },
        {
            id:8,
            value:'1990-1999'
        },
        {
            id:9,
            value:'1980-1989'
        },
        {
            id:10,
            value:'1970-1979'
        },
        {
            id:11,
            value:'1950-1969'
        },
        {
            id:12,
            value:'1900-1949'
        }
    ],
    OrderBy:[
        {
            id:1,
            value:'Latest'
        },
        {
            id:2,
            value:'Oldest'
        },
        {
            id:3,
            value:'Featured'
        },
        {
            id:4,
            value:'Seeds'
        },
        {
            id:5,
            value:'Peers'
        },
        {
            id:6,
            value:'Year'
        },
        {
            id:7,
            value:'IMBd Rating'
        },
        {
            id:8,
            value:'alphabetical'
        },
        {
            id:9,
            value:'Downloads'
        }
    ],
    Language:[
        {
            id:1,
            value:'en',
            title:'English'
        },
        {
            id:2,
            value:'foreign',
            title:'Foreign'
        },
        {
            id:3,
            value:'fr',
            title:'French (1737)'
        },
        {
            id:4,
            value:'ja',
            title:'Japanese (1607)'
        },
        {
            id:5,
            value:'it',
            title:'Italian (907)'
        },
        {
            id:6,
            value:'es',
            title:'Spanish (826)'
        },
        {
            id:7,
            value:'de',
            title:'German (684)'
        },
        {
            id:8,
            value:'zh',
            title:'Chinese (598)'
        },
        {
            id:9,
            value:'ko',
            title:'Korean (568)'
        },
        {
            id:10,
            value:'cn',
            title:'Cantonese (495)'
        },
        {
            id:11,
            value:'hi',
            title:'Hindi (360)'
        },
        {
            id:12,
            value:'ru',
            title:'Russian (251)'
        },
        {
            id:13,
            value:'sv',
            title:'Swedish (247)'
        },
        {
            id:14,
            value:'pt',
            title:'Portuguese (193)'
        },
        {
            id:15,
            value:'pl',
            title:'Polish (175)'
        },
        {
            id:16,
            value:'th',
            title:'Thai (121)'
        },
        {
            id:17,
            value:'da',
            title:'Danish (119)'
        },
        {
            id:18,
            value:'no',
            title:'Norwegian (86)'
        },
        {
            id:19,
            value:'nl',
            title:'Dutch (84)'
        },
        {
            id:20,
            value:'vi',
            title:'Vietnamese (69)'
        },
        {
            id:21,
            value:'ta',
            title:'Tamil (67)'
        },
        {
            id:22,
            value:'te',
            title:'Telugu (65)'
        },
        {
            id:23,
            value:'cs',
            title:'Czech (58)'
        },
        {
            id:24,
            value:'fi',
            title:'Finnish (58)'
        },
        {
            id:25,
            value:'tr',
            title:'Turkish (44)'
        },
        {
            id:26,
            value:'id',
            title:'Indonesian (39)'
        },
        {
            id:27,
            value:'fa',
            title:'Persian (30)'
        },
        {
            id:28,
            value:'hu',
            title:'Hungarian (28)'
        },
        {
            id:29,
            value:'tl',
            title:'Tagalog (27)'
        },
        {
            id:30,
            value:'el',
            title:'Greek (27)'
        },
        {
            id:31,
            value:'ar',
            title:'Arabic (25)'
        },
        {
            id:32,
            value:'he',
            title:'Hebrew (20)'
        },
        {
            id:33,
            value:'ro',
            title:'Romanian (19)'
        },
        {
            id:34,
            value:'et',
            title:'Estonian (18)'
        },
        {
            id:35,
            value:'bn',
            title:'Bangla (18)'
        },
        {
            id:36,
            value:'ur',
            title:'Urdu (15)'
        },
        {
            id:37,
            value:'ms',
            title:'Malay (13)'
        },
        {
            id:38,
            value:'ml',
            title:'Malayalam (13)'
        },
        {
            id:39,
            value:'is',
            title:'Icelandic (12)'
        },
        {
            id:40,
            value:'uk',
            title:'Ukrainian (11)'
        },
        {
            id:41,
            value:'sr',
            title:'Serbian (11)'
        },
        {
            id:42,
            value:'xx',
            title:'xx (9)'
        },
        {
            id:43,
            value:'ca',
            title:'Catalan (9)'
        },
        {
            id:44,
            value:'sk',
            title:'Slovak (8)'
        },
        {
            id:45,
            value:'pa',
            title:'Punjabi (7)'
        },
        {
            id:46,
            value:'af',
            title:'Afrikaans (6)'
        },
        {
            id:47,
            value:'wo',
            title:'Wolof (5)'
        },
        {
            id:48,
            value:'ka',
            title:'Georgian (5)'
        },
        {
            id:49,
            value:'kn',
            title:'Kannada (4)'
        },
        {
            id:50,
            value:'mr',
            title:'Marathi (4)'
        },
        {
            id:51,
            value:'bo',
            title:'Tibetan (4)'
        },
        {
            id:52,
            value:'lv',
            title:'Latvian (4)'
        },
        {
            id:53,
            value:'en',
            title:'Basque (4)'
        },
        {
            id:54,
            value:'am',
            title:'Amharic (3)'
        },
        {
            id:55,
            value:'la',
            title:'Latin (3)'
        },
        {
            id:56,
            value:'gl',
            title:'Galician (3)'
        },
        {
            id:57,
            value:'ps',
            title:'Pashto (2)'
        },
        {
            id:58,
            value:'ak',
            title:'Akan (2)'
        },
        {
            id:59,
            value:'hy',
            title:'Armenian (2)'
        },
        {
            id:60,
            value:'lt',
            title:'Lithuanian (2)'
        },
        {
            id:61,
            value:'sw',
            title:'Swahili (2)'
        },
        {
            id:62,
            value:'nb',
            title:'Norwegian Bokmål (2)'
        },
        {
            id:63,
            value:'bs',
            title:'Bosnian (2)'
        },
        {
            id:64,
            value:'mn',
            title:'Mongolian (2)'
        },
        {
            id:65,
            value:'so',
            title:'Somali (1)'
        },
        {
            id:66,
            value:'sl',
            title:'Slovenian (1)'
        },
        {
            id:67,
            value:'kk',
            title:'Kazakh (1)'
        },
        {
            id:68,
            value:'mt',
            title:'Maltese (1)'
        },
        {
            id:69,
            value:'cy',
            title:'Welsh (1)'
        },
        {
            id:70,
            value:'ku',
            title:'Kurdish (1)'
        },
        {
            id:71,
            value:'Igbo',
            title:'Igbo (1)'
        },
        {
            id:72,
            value:'zu',
            title:'Zulu (1)'
        },
        {
            id:73,
            value:'hr',
            title:'Croatian (1)'
        },
        {
            id:74,
            value:'ga',
            title:'Irish (1)'
        },
        {
            id:75,
            value:'be',
            title:'Belarusian (1)'
        },
        {
            id:76,
            value:'lg',
            title:'Ganda (1)'
        },
        {
            id:77,
            value:'st',
            title:'Southern Sotho (1)'
        },
        {
            id:78,
            value:'mi',
            title:'Maori (1)'
        },
        {
            id:79,
            value:'km',
            title:'Khmer (1)'
        },
        {
            id:80,
            value:'az',
            title:'Azerbaijani (1)'
        },
        {
            id:81,
            value:'mk',
            title:'Macedonian (1)'
        },
        {
            id:82,
            value:'ht',
            title:'Haitian Creole (1)'
        },
        {
            id:83,
            value:'sh',
            title:'Serbo-Croatian (1)'
        },
        {
            id:84,
            value:'ky',
            title:'Kyrgyz (1)'
        },
        {
            id:85,
            value:'os',
            title:'Ossetic (1)'
        },
        {
            id:86,
            value:'ab',
            title:'Abkhazian (1)'
        },
        {
            id:87,
            value:'lb',
            title:'Luxembourgish (1)'
        },
        {
            id:88,
            value:'yi',
            title:'Yiddish (1)'
        },
        {
            id:89,
            value:'aa',
            title:'Afar (1)'
        },
    ]
}